import React, { useId } from 'react';
interface SelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  label?: string;
  options: {
    value: string | number;
    label: string;
  }[];
  error?: string;
}
export function Select({
  label,
  options,
  error,
  className = '',
  id,
  ...props
}: SelectProps) {
  const selectId = id || useId();
  return <div className="w-full" data-id="element-175">
      {label && <label htmlFor={selectId} className="block text-sm font-medium text-slate-700 mb-1" data-id="element-176">
          {label}
        </label>}
      <select id={selectId} className={`flex h-10 w-full rounded-md border border-slate-300 bg-white px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-400 focus:border-transparent disabled:cursor-not-allowed disabled:opacity-50 ${error ? 'border-red-500 focus:ring-red-500' : ''} ${className}`} {...props} data-id="element-177">
        {options.map(opt => <option key={opt.value} value={opt.value} data-id="element-178">
            {opt.label}
          </option>)}
      </select>
      {error && <p className="mt-1 text-xs text-red-500" data-id="element-179">{error}</p>}
    </div>;
}